import { Anchor, Text, Group } from "@mantine/core"
import { IconCaretUp, IconCaretDown } from "@tabler/icons-react"

export const ToggleCollapse = ({
  seeMoreLabel,
  seeLessLabel,
  open,
  toggle,
}: {
  seeMoreLabel?: string
  seeLessLabel?: string
  open: boolean
  toggle: () => void
}) => {
  const showLabels = seeMoreLabel && seeLessLabel

  return (
    <Group wrap="nowrap" justify="space-between">
      <Anchor fw="bold" onClick={toggle}>
        <Group gap={4} align="center">
          {showLabels &&
            (open ? <Text>{seeLessLabel}</Text> : <Text>{seeMoreLabel}</Text>)}
          {open ? <IconCaretUp size={16} /> : <IconCaretDown size={16} />}
        </Group>
      </Anchor>
    </Group>
  )
}
